import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {BeforeCreateGameEvent} from "@/modules/base/events/BeforeCreateGameEvent";
import {NegotiatorFactory} from "@/modules/staff/services/factories/NegotiatorFactory";

@injectable()
export class GameCreationSubscriber implements EventSubscriber {
  constructor(
    @inject(NegotiatorFactory) private negotiatorFactory: NegotiatorFactory,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeCreateGameEvent, callback: this.onBeforeCreateGame},
    ];
  }

  async onBeforeCreateGame(event: BeforeCreateGameEvent): Promise<void> {
    await times(5).forEachAsync(() => this.negotiatorFactory.generate());
  }
}